// @generated by protoc-gen-es v2.13.0 with parameter "target=ts"
// @generated from file live178/v1/notification.proto (package live178.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { OperationResult, PageRequest, PageResponse } from "./common_pb";
import { file_live178_v1_common } from "./common_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file live178/v1/notification.proto.
 */
export const file_live178_v1_notification: GenFile = /*@__PURE__*/
  fileDesc("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", [file_google_protobuf_timestamp, file_live178_v1_common]);

/**
 * @generated from message live178.v1.Notification
 */
export type Notification = Message<"live178.v1.Notification"> & {
  /**
   * @generated from field: string notification_id = 1;
   */
  notificationId: string;

  /**
   * @generated from field: live178.v1.NotificationType type = 2;
   */
  type: NotificationType;

  /**
   * @generated from field: string title = 3;
   */
  title: string;

  /**
   * @generated from field: string body = 4;
   */
  body: string;

  /**
   * @generated from field: string target_url = 5;
   */
  targetUrl: string;

  /**
   * @generated from field: bool read = 6;
   */
  read: boolean;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 7;
   */
  createdAt?: Timestamp | undefined;

  /**
   * @generated from field: google.protobuf.Timestamp expires_at = 8;
   */
  expiresAt?: Timestamp | undefined;
};

/**
 * Describes the message live178.v1.Notification.
 * Use `create(NotificationSchema)` to create a new message.
 */
export const NotificationSchema: GenMessage<Notification> = /*@__PURE__*/
  messageDesc(file_live178_v1_notification, 0);

/**
 * @generated from message live178.v1.NotificationPreferences
 */
export type NotificationPreferences = Message<"live178.v1.NotificationPreferences"> & {
  /**
   * @generated from field: bool match_reminders = 1;
   */
  matchReminders: boolean;

  /**
   * @generated from field: bool live_reminders = 2;
   */
  liveReminders: boolean;

  /**
   * @generated from field: bool social_updates = 3;
   */
  socialUpdates: boolean;

  /**
   * @generated from field: bool wallet_updates = 4;
   */
  walletUpdates: boolean;

  /**
   * @generated from field: bool security_alerts = 5;
   */
  securityAlerts: boolean;

  /**
   * @generated from field: bool quiet_hours_enabled = 6;
   */
  quietHoursEnabled: boolean;

  /**
   * @generated from field: string quiet_hours_start = 7;
   */
  quietHoursStart: string;

  /**
   * @generated from field: string quiet_hours_end = 8;
   */
  quietHoursEnd: string;
};

/**
 * Describes the message live178.v1.NotificationPreferences.
 * Use `create(NotificationPreferencesSchema)` to create a new message.
 */
export const NotificationPreferencesSchema: GenMessage<NotificationPreferences> = /*@__PURE__*/
  messageDesc(file_live178_v1_notification, 1);

/**
 * @generated from message live178.v1.ListNotificationsRequest
 */
export type ListNotificationsRequest = Message<"live178.v1.ListNotificationsRequest"> & {
  /**
   * @generated from field: bool unread_only = 1;
   */
  unreadOnly: boolean;

  /**
   * @generated from field: live178.v1.PageRequest page = 2;
   */
  page?: PageRequest | undefined;
};

/**
 * Describes the message live178.v1.ListNotificationsRequest.
 * Use `create(ListNotificationsRequestSchema)` to create a new message.
 */
export const ListNotificationsRequestSchema: GenMessage<ListNotificationsRequest> = /*@__PURE__*/
  messageDesc(file_live178_v1_notification, 2);

/**
 * @generated from message live178.v1.ListNotificationsResponse
 */
export type ListNotificationsResponse = Message<"live178.v1.ListNotificationsResponse"> & {
  /**
   * @generated from field: repeated live178.v1.Notification notifications = 1;
   */
  notifications: Notification[];

  /**
   * @generated from field: int64 unread_count = 2;
   */
  unreadCount: bigint;

  /**
   * @generated from field: live178.v1.PageResponse page = 3;
   */
  page?: PageResponse | undefined;
};

/**
 * Describes the message live178.v1.ListNotificationsResponse.
 * Use `create(ListNotificationsResponseSchema)` to create a new message.
 */
export const ListNotificationsResponseSchema: GenMessage<ListNotificationsResponse> = /*@__PURE__*/
  messageDesc(file_live178_v1_notification, 3);

/**
 * @generated from message live178.v1.MarkNotificationsReadRequest
 */
export type MarkNotificationsReadRequest = Message<"live178.v1.MarkNotificationsReadRequest"> & {
  /**
   * @generated from field: repeated string notification_ids = 1;
   */
  notificationIds: string[];

  /**
   * @generated from field: bool all = 2;
   */
  all: boolean;
};

/**
 * Describes the message live178.v1.MarkNotificationsReadRequest.
 * Use `create(MarkNotificationsReadRequestSchema)` to create a new message.
 */
export const MarkNotificationsReadRequestSchema: GenMessage<MarkNotificationsReadRequest> = /*@__PURE__*/
  messageDesc(file_live178_v1_notification, 4);

/**
 * @generated from message live178.v1.MarkNotificationsReadResponse
 */
export type MarkNotificationsReadResponse = Message<"live178.v1.MarkNotificationsReadResponse"> & {
  /**
   * @generated from field: int32 updated_count = 1;
   */
  updatedCount: number;
};

/**
 * Describes the message live178.v1.MarkNotificationsReadResponse.
 * Use `create(MarkNotificationsReadResponseSchema)` to create a new message.
 */
export const MarkNotificationsReadResponseSchema: GenMessage<MarkNotificationsReadResponse> = /*@__PURE__*/
  messageDesc(file_live178_v1_notification, 5);

/**
 * @generated from message live178.v1.GetNotificationPreferencesRequest
 */
export type GetNotificationPreferencesRequest = Message<"live178.v1.GetNotificationPreferencesRequest"> & {
};

/**
 * Describes the message live178.v1.GetNotificationPreferencesRequest.
 * Use `create(GetNotificationPreferencesRequestSchema)` to create a new message.
 */
export const GetNotificationPreferencesRequestSchema: GenMessage<GetNotificationPreferencesRequest> = /*@__PURE__*/
  messageDesc(file_live178_v1_notification, 6);

/**
 * @generated from message live178.v1.GetNotificationPreferencesResponse
 */
export type GetNotificationPreferencesResponse = Message<"live178.v1.GetNotificationPreferencesResponse"> & {
  /**
   * @generated from field: live178.v1.NotificationPreferences preferences = 1;
   */
  preferences?: NotificationPreferences | undefined;
};

/**
 * Describes the message live178.v1.GetNotificationPreferencesResponse.
 * Use `create(GetNotificationPreferencesResponseSchema)` to create a new message.
 */
export const GetNotificationPreferencesResponseSchema: GenMessage<GetNotificationPreferencesResponse> = /*@__PURE__*/
  messageDesc(file_live178_v1_notification, 7);

/**
 * @generated from message live178.v1.UpdateNotificationPreferencesRequest
 */
export type UpdateNotificationPreferencesRequest = Message<"live178.v1.UpdateNotificationPreferencesRequest"> & {
  /**
   * @generated from field: live178.v1.NotificationPreferences preferences = 1;
   */
  preferences?: NotificationPreferences | undefined;
};

/**
 * Describes the message live178.v1.UpdateNotificationPreferencesRequest.
 * Use `create(UpdateNotificationPreferencesRequestSchema)` to create a new message.
 */
export const UpdateNotificationPreferencesRequestSchema: GenMessage<UpdateNotificationPreferencesRequest> = /*@__PURE__*/
  messageDesc(file_live178_v1_notification, 8);

/**
 * @generated from message live178.v1.UpdateNotificationPreferencesResponse
 */
export type UpdateNotificationPreferencesResponse = Message<"live178.v1.UpdateNotificationPreferencesResponse"> & {
  /**
   * @generated from field: live178.v1.NotificationPreferences preferences = 1;
   */
  preferences?: NotificationPreferences | undefined;
};

/**
 * Describes the message live178.v1.UpdateNotificationPreferencesResponse.
 * Use `create(UpdateNotificationPreferencesResponseSchema)` to create a new message.
 */
export const UpdateNotificationPreferencesResponseSchema: GenMessage<UpdateNotificationPreferencesResponse> = /*@__PURE__*/
  messageDesc(file_live178_v1_notification, 9);

/**
 * @generated from message live178.v1.RegisterPushTokenRequest
 */
export type RegisterPushTokenRequest = Message<"live178.v1.RegisterPushTokenRequest"> & {
  /**
   * @generated from field: string device_id = 1;
   */
  deviceId: string;

  /**
   * @generated from field: string platform = 2;
   */
  platform: string;

  /**
   * @generated from field: string provider = 3;
   */
  provider: string;

  /**
   * @generated from field: string token = 4;
   */
  token: string;
};

/**
 * Describes the message live178.v1.RegisterPushTokenRequest.
 * Use `create(RegisterPushTokenRequestSchema)` to create a new message.
 */
export const RegisterPushTokenRequestSchema: GenMessage<RegisterPushTokenRequest> = /*@__PURE__*/
  messageDesc(file_live178_v1_notification, 10);

/**
 * @generated from message live178.v1.RegisterPushTokenResponse
 */
export type RegisterPushTokenResponse = Message<"live178.v1.RegisterPushTokenResponse"> & {
  /**
   * @generated from field: live178.v1.OperationResult result = 1;
   */
  result?: OperationResult | undefined;
};

/**
 * Describes the message live178.v1.RegisterPushTokenResponse.
 * Use `create(RegisterPushTokenResponseSchema)` to create a new message.
 */
export const RegisterPushTokenResponseSchema: GenMessage<RegisterPushTokenResponse> = /*@__PURE__*/
  messageDesc(file_live178_v1_notification, 11);

/**
 * @generated from message live178.v1.UnregisterPushTokenRequest
 */
export type UnregisterPushTokenRequest = Message<"live178.v1.UnregisterPushTokenRequest"> & {
  /**
   * @generated from field: string device_id = 1;
   */
  deviceId: string;
};

/**
 * Describes the message live178.v1.UnregisterPushTokenRequest.
 * Use `create(UnregisterPushTokenRequestSchema)` to create a new message.
 */
export const UnregisterPushTokenRequestSchema: GenMessage<UnregisterPushTokenRequest> = /*@__PURE__*/
  messageDesc(file_live178_v1_notification, 12);

/**
 * @generated from message live178.v1.UnregisterPushTokenResponse
 */
export type UnregisterPushTokenResponse = Message<"live178.v1.UnregisterPushTokenResponse"> & {
  /**
   * @generated from field: live178.v1.OperationResult result = 1;
   */
  result?: OperationResult | undefined;
};

/**
 * Describes the message live178.v1.UnregisterPushTokenResponse.
 * Use `create(UnregisterPushTokenResponseSchema)` to create a new message.
 */
export const UnregisterPushTokenResponseSchema: GenMessage<UnregisterPushTokenResponse> = /*@__PURE__*/
  messageDesc(file_live178_v1_notification, 13);

/**
 * @generated from enum live178.v1.NotificationType
 */
export enum NotificationType {
  /**
   * @generated from enum value: NOTIFICATION_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: NOTIFICATION_TYPE_SYSTEM = 1;
   */
  SYSTEM = 1,

  /**
   * @generated from enum value: NOTIFICATION_TYPE_MATCH = 2;
   */
  MATCH = 2,

  /**
   * @generated from enum value: NOTIFICATION_TYPE_LIVE = 3;
   */
  LIVE = 3,

  /**
   * @generated from enum value: NOTIFICATION_TYPE_SOCIAL = 4;
   */
  SOCIAL = 4,

  /**
   * @generated from enum value: NOTIFICATION_TYPE_WALLET = 5;
   */
  WALLET = 5,

  /**
   * @generated from enum value: NOTIFICATION_TYPE_SECURITY = 6;
   */
  SECURITY = 6,
}

/**
 * Describes the enum live178.v1.NotificationType.
 */
export const NotificationTypeSchema: GenEnum<NotificationType> = /*@__PURE__*/
  enumDesc(file_live178_v1_notification, 0);

/**
 * @generated from service live178.v1.NotificationService
 */
export const NotificationService: GenService<{
  /**
   * @generated from rpc live178.v1.NotificationService.ListNotifications
   */
  listNotifications: {
    methodKind: "unary";
    input: typeof ListNotificationsRequestSchema;
    output: typeof ListNotificationsResponseSchema;
  },
  /**
   * @generated from rpc live178.v1.NotificationService.MarkNotificationsRead
   */
  markNotificationsRead: {
    methodKind: "unary";
    input: typeof MarkNotificationsReadRequestSchema;
    output: typeof MarkNotificationsReadResponseSchema;
  },
  /**
   * @generated from rpc live178.v1.NotificationService.GetNotificationPreferences
   */
  getNotificationPreferences: {
    methodKind: "unary";
    input: typeof GetNotificationPreferencesRequestSchema;
    output: typeof GetNotificationPreferencesResponseSchema;
  },
  /**
   * @generated from rpc live178.v1.NotificationService.UpdateNotificationPreferences
   */
  updateNotificationPreferences: {
    methodKind: "unary";
    input: typeof UpdateNotificationPreferencesRequestSchema;
    output: typeof UpdateNotificationPreferencesResponseSchema;
  },
  /**
   * @generated from rpc live178.v1.NotificationService.RegisterPushToken
   */
  registerPushToken: {
    methodKind: "unary";
    input: typeof RegisterPushTokenRequestSchema;
    output: typeof RegisterPushTokenResponseSchema;
  },
  /**
   * @generated from rpc live178.v1.NotificationService.UnregisterPushToken
   */
  unregisterPushToken: {
    methodKind: "unary";
    input: typeof UnregisterPushTokenRequestSchema;
    output: typeof UnregisterPushTokenResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_live178_v1_notification, 0);

